/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Subscription_Rights_Usage_WeekInputs */

const fr_admin_subscription_rights_usage_week = /** @type {(inputs: Admin_Subscription_Rights_Usage_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consommation de la semaine`)
};

/**

* @param {Admin_Subscription_Rights_Usage_WeekInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const admin_subscription_rights_usage_week = /** @type {((inputs?: Admin_Subscription_Rights_Usage_WeekInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Subscription_Rights_Usage_WeekInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_admin_subscription_rights_usage_week(inputs)
});